module.exports = __webpack_public_path__ + "img/unknown-error.46039e22.png";